module.exports = __webpack_public_path__ + "img/set.b94ffa18.png";